import { Types } from '@store/types';

const initialState = {};

const DesignToolReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.FETCH_DESIGN_INFO:
			return action.payload;
		case Types.CLEAR_DESIGN_TOOL:
			return {};
		default:
			return state;
	}
};

export default DesignToolReducer;
